<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="3">
      <FilterDates :fetchData="fetchMovements" :dateRange="true" />
    </v-col>
  </v-row>
</template>

<script>
import FilterDates from '@/components/filters/FilterDates'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MovementListFilter',

  components: { FilterDates },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['fetchMovements']),
  },
}
</script>
